import { type App } from 'vue'

export default {
  install(app: App) {
    const handlers = new WeakMap()

    app.directive('delay-hover', {
      beforeMount(el, binding) {
        let timer: ReturnType<typeof setTimeout>
        const onEnter = () => {
          timer = setTimeout(binding.value, 150)
        }
        const onLeave = () => {
          if (timer) clearTimeout(timer)
        }
        el.addEventListener('mouseenter', onEnter)
        el.addEventListener('mouseleave', onLeave)
        handlers.set(el, [onEnter, onLeave])
      },
      unmounted(el) {
        if (handlers.get(el)) {
          el.removeEventListener('mouseenter', handlers.get(el)[0])
          el.removeEventListener('mouseleave', handlers.get(el)[1])
        }
        handlers.delete(el)
      },
    })
  },
}
